const navigation = () => {
  return [
    {
      title: 'Dashboard',
      path: '/dashboard',
      // icon: 'tabler:smart-home',
    },
    {
      title: 'True Claim',
      icon: 'tabler:smart-home',
      subject: 'true_claim',
      children: [
        {
          path: '/otp-less',
          action: 'read',
          subject: 'otp_less',
          title: 'OTP Less Delivered Return',
          icon: 'tabler:shield',
        },
        {
          path: '/payment',
          action: 'read',
          subject: 'payment',
          title: 'Payment Not Received',
          icon: 'tabler:shield',
        },
        {
          path: '/returns',
          action: 'read',
          subject: 'returns',
          title: 'Return Not Received',
          icon: 'tabler:shield',
        },
        {
          path: '/lost',
          action: 'read',
          subject: '',
          title: 'Lost',
          icon: 'tabler:shield',
        },
        {
          path: '/upload-excel',
          action: 'read',
          subject: '',
          title: 'Upload Auto TC',
          icon: 'tabler:shield',
        },
      ]
    },
    {
      title: 'Smart Claim',
      icon: 'tabler:smart-home',
      subject: 'smart_claim',
      children: [
        {
          path: '/customer-return',
          action: 'read',
          subject: 'customer_return',
          title: 'Customer Return',
          icon: 'tabler:shield',
        },
        {
          path: '/wrong-rto',
          action: 'read',
          subject: 'wrong_rto',
          title: 'Wrong Rto',
          icon: 'tabler:shield',
        },
        {
          path: '/non-barcode-rto',
          action: 'read',
          subject: 'non_barcode_rto',
          title: 'Non Barcode Rto',
          icon: 'tabler:shield',
        },
        {
          path: '/damage',
          action: 'read',
          subject: 'damage',
          title: 'Damage',
          icon: 'tabler:shield',
        },
        {
          path: '/missing-qty',
          action: 'read',
          subject: 'missing_qty',
          title: 'Missing Qty',
          icon: 'tabler:shield',
        },
        {
          path: '/used',
          action: 'read',
          subject: 'used',
          title: 'Used Return',
          icon: 'tabler:shield',
        },
      ]
    },
    {
      title: 'Report',
      path: '/report',
    },
    {
      title: 'Upload',
      path: '/upload',
    },
  ]
}

export default navigation
